@if (message().sender; as sender) {
  <procure-avatar
    class="avatar"
    [name]="sender.name"
    [avatar]="sender.avatarUrl"
  />
} @else {
  <div class="system">
    <img
      class="system-icon"
      alt="ABB Procure"
      [src]="'/assets/images/logo-procure-brand-small.svg' | fileHash"
    />
  </div>
}
<ng-template #system>
  <div class="system">
    <img
      class="system-icon"
      alt="ABB Procure"
      [src]="'/assets/images/logo-procure-brand-small.svg' | fileHash"
    />
  </div>
</ng-template>
<div class="detail">
  <div class="header">
    <div
      class="title"
      [class.unread]="!message().isRead"
    >
      @if (message().data.entityNumber; as entityNumber) {
        <procure-entity-badge
          [label]="entityNumber"
          [condensed]="condensed()"
        />
      }
      {{ message().title }}
    </div>
    <div class="date">
      {{ message().createdOn | date: "short" }}
      @if (message().isArchived) {
        - Archived
      }
    </div>
  </div>
  @if (message().message && message().message !== "<p></p>") {
    <div
      class="content"
      [innerHTML]="message().message | sanitize"
    ></div>
  }
</div>
<div class="actions">
  <button
    procure-button
    variant="ghost"
    condensed
    color="black"
    [matTooltip]="message().isArchived ? 'Unarchive' : 'Archive'"
    (click)="toggleArchive.emit($event)"
  >
    <mat-icon class="icon">{{ message().isArchived ? "unarchive" : "archive" }}</mat-icon>
  </button>
  <button
    procure-button
    variant="ghost"
    condensed
    [color]="message().isRead ? 'black' : 'primary'"
    [matTooltip]="message().isRead ? 'Mark as unread' : 'Mark as read'"
    (click)="toggleRead.emit($event)"
  >
    <mat-icon class="icon">{{ message().isRead ? "radio_button_unchecked" : "radio_button_checked" }}</mat-icon>
  </button>
</div>
